export class EvaluationSubType {
    public static values = [
        "MDH/DHS Collaboration"
    ];
}